import { render, staticRenderFns } from "./Practice.vue?vue&type=template&id=30cd38d6&scoped=true&"
import script from "./Practice.vue?vue&type=script&lang=js&"
export * from "./Practice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cd38d6",
  null
  
)

export default component.exports